module.exports = __webpack_public_path__ + "img/checklist.d5f3a658.svg";